const bloopAmount = 1.1;

const transform = {
    bloopAmount,
    bloopScale: `scale(${bloopAmount})`,
};

export default transform;
